import React from 'react'
import { LogOut, CheckCircle, Upload } from 'lucide-react'
import { StatCard } from './UI/StatCard'
import { ShareService } from './../Utils/shareService'
import { Heart, Users, Gift } from 'lucide-react'

export const ProfileHeader = ({ user, referralStats, onLogout }) => {
  return (
    <div className="relative bg-white rounded-3xl shadow-xl border border-gray-200/50 overflow-hidden mb-8">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-teal-50 via-white to-emerald-50"></div>
      <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-bl from-teal-100/50 to-transparent rounded-bl-full"></div>
      
      <div className="relative p-8">
        {/* Logout Button */}
        <div className="absolute top-6 right-6">
          <button
            onClick={onLogout}
            className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-red-600 rounded-lg hover:bg-gray-100 transition-all duration-200"
            title="Logout"
          >
            <LogOut className="w-4 h-4" />
            <span className="text-sm font-medium">Logout</span>
          </button>
        </div>

        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8 pt-8">
          {/* Profile Info */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6">
            {/* Avatar */}
            <div className="relative group">
              <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-2xl bg-gradient-to-br from-teal-500 to-emerald-600 flex items-center justify-center text-white text-2xl sm:text-3xl font-bold shadow-lg">
                {user.profile_picture ? (
                  <img
                    src={user.profile_picture}
                    alt={`${user.first_name} ${user.last_name}`}
                    className="w-full h-full object-cover rounded-2xl"
                  />
                ) : (
                  ShareService.getInitials(user.first_name, user.last_name)
                )}
              </div>
              <button className="absolute -bottom-2 -right-2 w-8 h-8 bg-white rounded-full shadow-lg flex items-center justify-center text-gray-600 hover:text-teal-600 transition-colors duration-200">
                <Upload className="w-4 h-4" />
              </button>
            </div>

            {/* User Details */}
            <div className="space-y-2">
              <div className="flex items-center gap-3">
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
                  {user.first_name} {user.last_name}
                </h1>
                {user.email_verified && (
                  <CheckCircle className="w-6 h-6 text-green-500" title="Verified User" />
                )}
              </div>
              <p className="text-gray-600 font-medium">@{user.username}</p>
              <div className="flex items-center gap-2">
                <span className="px-3 py-1 bg-teal-100 text-teal-700 rounded-full text-sm font-medium capitalize">
                  {user.role}
                </span>
                <span className="text-gray-500 text-sm">
                  Member since {new Date(user.date_joined).toLocaleDateString('en-US', { 
                    year: 'numeric', 
                    month: 'long' 
                  })}
                </span>
              </div>
            </div>
          </div>

          {/* Quick Stats */}
          <div className="grid grid-cols-3 gap-6 lg:gap-8">
            <StatCard
              icon={Heart}
              value={user.saved_properties_count || 0}
              label="Saved"
              bgColor="bg-teal-100"
              iconColor="text-teal-600"
            />
            <StatCard
              icon={Users}
              value={referralStats?.total_referrals || user.referrals_count || 0}
              label="Referrals"
              bgColor="bg-blue-100"
              iconColor="text-blue-600"
            />
            <StatCard
              icon={Gift}
              value={referralStats?.total_rewards_earned || user.total_rewards || 0}
              label="AED Earned"
              bgColor="bg-green-100"
              iconColor="text-green-600"
            />
          </div>
        </div>
      </div>
    </div>
  )
}